import { Routes } from '@angular/router';
import { canActivateAuthorized, canMatchAuthorized } from '@app/core/auth/guards/auth.guard';

export const APP_ROUTES: Routes = [
  {
    path: 'login',
    loadChildren: () => import('@app/pages-core/login-page').then((r) => r.LOGIN_PAGE_ROUTES),
  },
  {
    path: 'registration',
    loadChildren: () => import('@app/pages-core/registration-page').then((r) => r.REGISTRATION_PAGE_ROUTES),
  },
  {
    path: 'reset',
    loadChildren: () => import('@app/pages-core/reset-password-page').then((r) => r.RESET_PASSWORD_PAGE_ROUTES),
  },
  {
    path: '',
    loadChildren: () => import('@app/pages-core/main-container-page').then((r) => r.MAIN_CONTAINER_PAGE_ROUTES),
    canActivate: [canActivateAuthorized],
    canMatch: [canMatchAuthorized],
  },
];
